/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .json-editor-toolbar {
    position: absolute;
    top: 2px;
    right: 2px;
    z-index: 10;
  }

  .json-editor-container {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 9;
  }

  .json-editor-container :where(.cm-editor),
  .json-editor-container :where(.cm-theme-dark) {
    height: 100%;
  }

  .disabled-json-toolbar-btn {
    opacity: 0.65;
  }
`;
